import { QuestionAnswerResult } from "src/app/_models/QuestionResults";

export interface SkillsCheckQandAState {
	course: number;
	questionAnswerState: QuestionAnswerResult[];
}

export const initialSkillsCheckQandAState : SkillsCheckQandAState = {
	course: 0,
	questionAnswerState: []
}